module.exports = __webpack_public_path__ + "static/img/tab3pic.42a59af7.png";